import React from "react";
import {
    Modal,
    Box,
    Typography,
    TextField,
    Button,
} from "@mui/material";

import { useForm } from "react-hook-form";
import CancelPresentationIconButton from "../../common/components/Buttons/CancelPresentationIconButton";
import CommonTransactionTable from "../../common/components/CommonTable/CommonTransactionTable";
import CommonButton from "../../common/components/Buttons/CommonButton";
import CommonBackDrop from "../../common/components/CommonBackDrop/CommonBackDrop";
import ConfirmationModal from "../../common/components/ConfirmationModal";

const ModalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    boxShadow: 20,
    width: "65%",
    maxWidth: "100%",
    p: 3,
    // overflowY: "scroll",
};
const advanceDetails = [
    {
        id: 1,
        date: "2025-08-01",
        amount: 5000,
        consumeAmount: 2000,
    },
    {
        id: 2,
        date: "2025-08-05",
        amount: 3000,
        consumeAmount: 1500,
    },
    {
        id: 3,
        date: "2025-08-10",
        amount: 7000,
        consumeAmount: 4000,
    },
];
export default function AdvanceConsumeDetails({
    open,
    handleClose,
    setConsumedAdvanceFlag,
    consumeAdvaceData,
    setConsumeAdvanceData,
    setValue,
    handleConsumeAmountChange,
    setNetPayableAmountVal,
    getValues,
    billAmount
}) {

    console.log("datafrombillinfomodal", open,
        handleClose,
        setConsumedAdvanceFlag);

    const defaultValues = {}

    const { handleSubmit, reset, register, setError, clearErrors, formState: { errors } } = useForm({
        mode: "onChange",
        defaultValues
    })

    const [advanceDetails, setAdvanceDetails] = React.useState([
        {
            id: 1,
            date: "2025-08-01",
            amount: 5000,
            consumeAmount: 2000,
        },
        {
            id: 2,
            date: "2025-08-05",
            amount: 3000,
            consumeAmount: 1500,
        },
        {
            id: 3,
            date: "2025-08-10",
            amount: 7000,
            consumeAmount: 4000,
        },
    ])
    const [openBackdrop, setOpenBackdrop] = React.useState(false)
    const [openConfirmModal, setOpenConfirmModal] = React.useState(false)
    const handleCloseConfirmation = () => setOpenConfirmModal(false)
    // function onSubmitData(data) {
    //     console.log("onSubmitDataonSubmitDataonSubmitData", data, "advanceDetailsadvanceDetails", consumeAdvaceData);
    //     const totalConsumeAmount = consumeAdvaceData?.reduce((total, item) => total + Number(item?.consumeAmount || 0), 0)
    //     setValue("consumeAdvance", true);

    //     setValue("consumeAmount", totalConsumeAmount);
    //     // setConsumedAdvanceFlag(false)
    //     handleConsumeAmountChange(totalConsumeAmount);
    //       setTimeout(() => {
    //     handleClose();
    //     setConsumedAdvanceFlag(false)
    // }, 0);
    // }

    function onSubmitData(data) {

        const totalConsumeAmount = consumeAdvaceData?.reduce(
            (total, item) => total + Number(item?.consumeAmount || 0),
            0
        );

        const billAmount = Number(getValues("netPayableAmount") || 0);

        const remainingAmount = billAmount - totalConsumeAmount;

        const remainingAmt = remainingAmount <= 0 ? 0 : Number(remainingAmount.toFixed(2));

        console.log("remainingAmtremainingAmtremainingAmt", totalConsumeAmount);


        setValue("consumeAdvance", true);
        setValue("consumeAmount", totalConsumeAmount);


        setNetPayableAmountVal(remainingAmt);

        handleConsumeAmountChange(totalConsumeAmount);
        // setConsumedAdvanceFlag(false)

        handleClose();
    }




    console.log("errorserrorserrorserrorserrors", errors);


    function renderInput(row, index, header) {
        console.log("headerheaderheaderheader", header);

        return (<>
            <input
                type="number"
                step="0.01"
                name={`consumeAdvanceAmt${index}`}
                {...register(`consumeAdvanceAmt${index}`, {
                    onChange: (e) => {
                        let amtValue = e?.target?.value;

                        // convert to 2 decimal value
                        const formattedValue =
                            amtValue !== ""
                                ? Number(amtValue).toFixed(2)
                                : "";

                        console.log("get amountof the field", formattedValue);

                        const updateData = consumeAdvaceData?.map((item, i) =>
                            i === index
                                ? {
                                    ...item,
                                    consumeAmount: Number(formattedValue),
                                }
                                : item
                        );

                        setConsumeAdvanceData(updateData);

                        if (
                            Number(formattedValue) >
                            consumeAdvaceData[index]?.Balance
                        ) {
                            setError(`consumeAdvanceAmt${index}`, {
                                type: "manual",
                                message:
                                    "Consume amount cannot be greater than amount",
                            });
                        } else {
                            clearErrors(`consumeAdvanceAmt${index}`);
                        }
                    },
                })}
                className={`
    border rounded outline-none
    ${errors?.[`consumeAdvanceAmt${index}`]
                        ? "border-red-500 focus:border-red-500 focus:ring-red-500"
                        : "border-gray-500 focus:border-blue-500"
                    }
  `}
            />
        </>)
    }
    return (
        <div>
            <Modal open={open}>
                <Box sx={ModalStyle}>
                    <CancelPresentationIconButton
                        onClick={() => {
                            handleClose();
                            setConsumedAdvanceFlag(false)
                            //   reset(defaultValues);
                            //   setEditRowData(null);
                            //   setContent1();
                        }}
                    />
                    <form onSubmit={handleSubmit(onSubmitData)}>
                        <div className="space-y-2">
                            <div className="flex justify-between gap-2 ">
                                <div>
                                    <label className="flex font-semibold text-lg">
                                        Advance Details
                                    </label>
                                </div>
                                <div>
                                    <label className="flex font-semibold text-lg px-10">
                                        Bill Amount (₹)   :  {billAmount}

                                    </label>
                                </div>
                            </div>


                            {consumeAdvaceData?.length > 0 && <CommonTransactionTable dataResult={consumeAdvaceData} renderInput={renderInput} editableColumns={"consumeAmount"} tableClass="capitalize" highlightRow={false} />
                            }              <div className="flex justify-end gap-2">
                                <CommonButton
                                    type="button"
                                    label="Reset"
                                    className="border border-customRed text-customRed"
                                    onClick={() => {
                                        reset(defaultValues);
                                    }}
                                />
                                {Object?.keys(errors)?.length === 0 ? <CommonButton
                                    type="submit"
                                    label="Save"
                                    className="bg-customGreen text-white"
                                /> : null}
                            </div>
                        </div>
                    </form>
                </Box>
            </Modal>
            <CommonBackDrop openBackdrop={openBackdrop} />
            <ConfirmationModal
                confirmationOpen={openConfirmModal}
                confirmationHandleClose={handleCloseConfirmation}
                // confirmationSubmitFunc={postData}
                confirmationLabel="Confirmation"
                confirmationMsg="Are you sure want to add this Record ?"
                confirmationButtonMsg="Add"
            />
        </div>
    );
}